import { useLocation } from "react-router";

const useHash = acceptableHashes => {
  const { hash } = useLocation();
  let selectedHash = null;

  if (acceptableHashes?.length) {
    selectedHash = acceptableHashes.includes(
      decodeURI(hash).toLowerCase().replace("#", ""),
    )
      ? decodeURI(hash).toLowerCase().replace("#", "")
      : acceptableHashes[0];
  } else {
    selectedHash = decodeURI(hash).toLowerCase().replace("#", "");
  }

  return selectedHash;
};

export default useHash;
